import { registeredTableHandlers } from '@/global/components/view-layouts/tabs-layout/config/registered-table-handlers'
import { api } from '@/global/services/api'

export default {
  methods: {
    showPartnerLocationOnMap (event) {
      const { geolocation } = event?.rowData || {}
      const latitude = geolocation?.lat
      const longitude = geolocation?.lng

      if (!latitude || !longitude) {
        return
      }

      this.$set(this.chooseLocationDialogConfig, 'markers', {
        lat: latitude,
        lng: longitude
      })
      this.$set(this.chooseLocationDialogConfig, 'title', this.$t('base.location_preview'))
      this.$set(this.chooseLocationDialogConfig, 'createMode', false)
      this.$set(this.chooseLocationDialogConfig, 'show', true)
    },

    onPartnerLocationRemove (event) {
      const { name } = event?.data || {}
      this.$set(this.informationDialogConfig, 'message', this.$t('administration/partner_location.confirm_delete'))
      this.$set(this.informationDialogConfig, 'negativeButtonText', this.$t('base.cancel'))
      this.$set(this.informationDialogConfig, 'positiveButtonText', this.$t('base.confirm'))
      this.$set(this.informationDialogConfig, 'title', this.$t('administration/partner_location.delete') + (name ? ' - ' + name : ''))
      this.$set(this.informationDialogConfig, 'confirmCallbackFunction', async () => await this.removePartnerLocationCallback(event))
      this.$set(this.informationDialogConfig, 'showDialog', true)
    },

    async removePartnerLocationCallback (event) {
      try {
        const { id } = event?.data || {}
        const { fetchData } = registeredTableHandlers?.partnerLocations || {}

        if (id) {
          await api('administration').delete(`partner-locations/${id}`)

          this.$set(this.informationDialogConfig, 'showDialog', false)
          // Refresh table data
          fetchData?.()
        }
      }
      catch (exception) {
        console.error(exception)
      }
    }
  }
}
